'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (url) {
    return new Promise(function (resolve, reject) {

        var existingTag = document.querySelector('script[src="' + url + '"]');

        if (existingTag) {
            var previousOnLoadCallback = existingTag.onload;

            existingTag.onload = function () {

                try {
                    if (previousOnLoadCallback) previousOnLoadCallback();
                } catch (err) {
                    window.console.error(err);
                }

                resolve();
            };

            return;
        }

        var script = document.createElement('script');
        script.onload = resolve;
        script.async = true;
        script.src = url;
        (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
    });
};

//# sourceMappingURL=loadScript.js.map